import type { TranslationOverrides } from '@lib/types/translations'
import type { SupportedLocale } from '@lib/types/i18n.types'
import { partition, set } from 'lodash-es'

function isAllUpper(str: string): boolean {
  return str === str.toUpperCase()
}

function applyCasing(replacement: string, original: string): string {
  if (isAllUpper(original)) {
    return replacement.toUpperCase()
  }

  return replacement
}

function findAndReplaceTranslationMessagesWithOverrides({
  overrides,
  messages,
}: {
  overrides: Record<string, string>
  messages?: any
}) {
  for (const key in messages) {
    if (typeof messages[key] === 'object' && messages[key] !== null) {
      findAndReplaceTranslationMessagesWithOverrides({
        overrides,
        messages: messages[key],
      })
    } else if (typeof messages[key] === 'string') {
      for (const replKey in overrides) {
        const re = new RegExp('\\b' + replKey + '\\b', 'gi')
        messages[key] = (messages[key] as string).replace(re, (match) => {
          return applyCasing(overrides[replKey], match)
        })
      }
    }
  }
}

export const replaceTranslationMessagesWithOverrides = ({
  overrides,
  messages,
  locale,
}: {
  overrides: TranslationOverrides
  messages?: any
  locale: SupportedLocale
}) => {
  const localeOverrides = overrides[locale]
  if (!localeOverrides) {
    return
  }

  const [findReplaceOverrideKeys, fullOverrideKeys] = partition(
    Object.keys(localeOverrides),
    (key) => !/[a-zA-Z0-9]\.[a-zA-Z0-9]/.test(key),
  )

  fullOverrideKeys.forEach((key) => {
    set(messages, key, localeOverrides[key])
  })

  findAndReplaceTranslationMessagesWithOverrides({
    overrides: Object.fromEntries(findReplaceOverrideKeys.map((key) => [key, localeOverrides[key]])),
    messages,
  })
}
